export * from '@erp/ui/formatted-input';
